<template>
  <div style="margin-top:5px;margin-bottom:5px;">
    <md-toolbar v-if="tabInfos">
      <span class="md-title">학습 목표 :&nbsp;&nbsp;</span>
      <template v-for="(str, idx) in tabInfos">
        <div
          :key="idx"
          style="margin:2px;"
        >
          <md-chip>{{ str }}</md-chip>
        </div>
      </template>
    </md-toolbar>
  </div>
</template>

<script>
export default {
  name: 'StepDescChip',
  props: {
    tabInfos: {
      type: Array,
      required: true
    }
  }
}
</script>
<style>
.md-tab {
  flex: 1 0 auto !important; 
}
</style>